import { NavLink } from "react-router-dom";
import { Building2, LayoutDashboard, Menu, MessagesSquare, Users } from "lucide-react";
import { cn } from "@/lib/utils";
import { can } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";

const ITEMS = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, m: null, key: "dashboard" },
  { to: "/chat", label: "Chat", icon: MessagesSquare, m: "chat", key: "chat" },
  { to: "/leads", label: "Leads", icon: Users, m: "leads", key: "leads" },
  { to: "/properties", label: "Properties", icon: Building2, m: "properties", key: "properties" },
  { to: "/more", label: "More", icon: Menu, m: null, key: "more" },
];

export default function BottomNav() {
  const { user } = useAuth();
  const items = ITEMS.filter((i) => !i.m || can(user, i.m));
  return (
    <nav className="glass fixed inset-x-0 bottom-0 z-40 border-t md:hidden safe-bottom" data-testid="mobile-bottom-nav">
      <div className="flex h-16 items-stretch">
        {items.map(({ to, label, icon: Icon, key }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={`nav-${key}-link`}
            className={({ isActive }) =>
              cn(
                "flex flex-1 flex-col items-center justify-center gap-1 text-[11px] font-semibold transition-colors",
                isActive ? "text-primary" : "text-muted-foreground",
              )
            }
          >
            {({ isActive }) => (
              <>
                <span className={cn("flex h-7 w-12 items-center justify-center rounded-full transition-colors", isActive && "bg-primary/10")}>
                  <Icon className="h-5 w-5" />
                </span>
                {label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
